import { Amplify } from "aws-amplify";
import { IAuthBootstrapper } from "../domain/IAuthBootstraper";

export class CognitoAuthBootstrapper implements IAuthBootstrapper {
    initialize(userPoolId: string, userPoolClientId: string): void {
        Amplify.configure({
            Auth: {
                Cognito: {
                    userPoolId,
                    userPoolClientId,
                },
            },
        });
    }
}
